import { useAtom } from 'jotai'
import React from 'react'
import { Checkbox, Container, Header, Segment } from 'semantic-ui-react'
import { featureFlagsAtom } from '../atoms/featureFlags'

export const FeatureFlagsPage = () => {
  const [flags, setFlags] = useAtom(featureFlagsAtom)
  const { enableRemapUI } = flags

  const toggleFlag = (key: string) => {
    setFlags((state) => {
      const newState: any = { ...state }
      newState[key] = !newState[key]

      return newState
    })
  }

  return (
    <>
      <Segment basic padded style={{ margin: 0 }} attached="bottom">
        <Container text>
          <Header as="h2">Feature Flags</Header>
          <Checkbox
            checked={enableRemapUI}
            onChange={() => toggleFlag('enableRemapUI')}
            label="Enable remap UI"
          />
        </Container>
      </Segment>
      <Segment basic padded style={{ margin: 0 }} attached="bottom">
        <Container text>
          <pre>{JSON.stringify(flags)}</pre>
        </Container>
      </Segment>
    </>
  )
}
